import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TaskList, Activity } from 'src/app/models/activity';
import { Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { getTasks, UpdateActivity, GoToProblemDetails, SetAppView, getAppView, getInProgressMyTask
  , SetInProgressMyTask, MenuItem, getMenus, GetMenuOption, 
  GetTasks} from 'src/app/state-management';
import { DeviceDetectorService } from 'ngx-device-detector';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-mytasks-component',
    templateUrl: './mytasks.component.html',
    styleUrls: ['./mytasks.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class MyTasksComponent implements OnInit {
  tasks$: Observable<TaskList[]>;
  appView$: Observable<string>;
  inProgressMyTask$: Observable<boolean>;

  taskInProgress = -1;

  private ngUnsubscribe: Subject<void> = new Subject();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<{}>,
    private deviceService: DeviceDetectorService,
  ) {
    this.tasks$ = this.store.select(getTasks);
    this.appView$ = this.store.select(getAppView);
    this.inProgressMyTask$ = this.store.select(getInProgressMyTask);
  }

  ngOnInit() {
    // detect device type
    if (this.deviceService.isDesktop()) {
      this.store.dispatch(new SetAppView('desktop'));
    } else if (this.deviceService.isTablet()) {
      this.store.dispatch(new SetAppView('tablet'));
    } else if (this.deviceService.isMobile()) {
      this.store.dispatch(new SetAppView('mobile'));
    }
    this.store.dispatch(new GetTasks());
  }

  completeTask(task: TaskList, index: number) {
    this.store.dispatch(new SetInProgressMyTask(true));
    this.taskInProgress = index;

    const modifiedActivity: Activity = {
      activityType_RefId: task.activityType_Id,
      note: task.note,
      user_RefId: task.user_Id === 0 ? null : task.user_Id,
      role_RefId: task.role_Id === 0 ? null : task.role_Id,
      problem_RefId: task.problem_Id,
      activityDate: task.activityDate,
      activityFollowUpdate: task.activityFollowUpdate,
      activityDateClosed: null,
      createdBy: task.createdBy_Id
    };

    if (!task.activityDateClosed) {
      modifiedActivity.activityDateClosed = new Date();
      this.store.dispatch(new UpdateActivity({ activityId: task.activity_Id, activity: modifiedActivity }));
    } else {
      this.store.dispatch(new UpdateActivity({ activityId: task.activity_Id, activity: modifiedActivity }));
    }
  }

  toDetails(problemNum: string, activityNo: string) {
    this.store.dispatch(new GoToProblemDetails({ problemNo: problemNum, activityNo: activityNo }));
  }
}
